const moment = require('moment')

class CoreHelper {
  static toArrayQueryString (params) {
    let query = Object.keys(params).map(function (key) {
      return encodeURIComponent(key) + '=' +
        encodeURIComponent(params[key])
    }).join('&')

    return String(query)
  }
  static friendly (text) {
    return text.replace('_', ' ')
  }
  static arred (val) {
    val = Math.round(val * 100) / 100
    return parseFloat(val.toFixed(2))
  }
  static toCurrency (val) {
    val = this.arred(val)
    val = val.toString().replace('.',',').split( /(?=(?:\d{3})+(?:\,|$))/g ).join( "." )
    return `R$ ${val}`
  }
  static toDate (val) {
    return moment(val).format('HH:mm DD/MM/YYYY')
  }
  static isToday (date) {
    const customDate = new Date(date)
    const today = new Date()

    return customDate.getDate() === today.getDate() &&
      customDate.getMonth() === today.getMonth() &&
      customDate.getFullYear() === today.getFullYear()
  }
  static compareDates(a, b) {
    let x = moment(a, 'DD/MM/YYYY')
    let y = moment(b, 'DD/MM/YYYY')

    if (x.isBefore(y)) {
      return -1
    }

    if (y.isAfter(x)) {
      return 1
    }

    return 0

  }
}

export default CoreHelper
